var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.693,
    height: 30.726,
    viewBox: "0 0 44.693 30.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card_3_",
    "data-name": "credit-card (3)",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15171",
    "data-name": "Path 15171",
    d: "M39.8,80H4.888A4.894,4.894,0,0,0,0,84.888v20.95a4.894,4.894,0,0,0,4.888,4.888H39.8a4.894,4.894,0,0,0,4.888-4.888V84.888A4.894,4.894,0,0,0,39.8,80ZM4.888,82.793H39.8A2.1,2.1,0,0,1,41.9,84.888v2.793H2.793V84.888A2.1,2.1,0,0,1,4.888,82.793ZM39.8,107.933H4.888a2.1,2.1,0,0,1-2.095-2.095V90.475H41.9v15.363A2.1,2.1,0,0,1,39.8,107.933Z",
    fill: "#51aabc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15172",
    "data-name": "Path 15172",
    d: "M82.793,308.19H81.4a1.4,1.4,0,0,1-1.4-1.4v-1.4a1.4,1.4,0,0,1,1.4-1.4h1.4a1.4,1.4,0,0,1,1.4,1.4v1.4A1.4,1.4,0,0,1,82.793,308.19Z",
    transform: "translate(-73.017 -204.447)",
    fill: "#51aabc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbIcon);
export default __webpack_public_path__ + "static/media/cb-icon.1b11d0f9.svg";
export { ForwardRef as ReactComponent };